import {
  BLACK_BAR_COLOR,
  GREEN_BAR_COLOR,
  LIGHT_GREEN_BAR_COLOR,
} from '@constants/charts';
import '../styles/sales_lift_chart.scss';

export type DataItem = {
  name: string;
  sales: number;
  lift: number;
  confidenceLevel: number;
};

export const salesLiftChartColors = [
  BLACK_BAR_COLOR,
  GREEN_BAR_COLOR,
  LIGHT_GREEN_BAR_COLOR,
];
